import { createFileRoute } from "@tanstack/react-router";
import DEEuro6 from "@/pages/landing/DEEuro6";
import { routeHead } from "@/lib/seo/route-head";

export const Route = createFileRoute("/de/euro-6-fahrzeuge/")({
  head: () => routeHead("/de/euro-6-fahrzeuge/"),
  component: RouteComponent,
});

function RouteComponent() {
  return (
    <DEEuro6 />
  );
}
